const stepsEnum = {
  INTRO: 'INTRO', // page one
  UPGRADE: 'UPGRADE', // page two
  SUCCESS: 'SUCCESS', // page three-a
  FAILURE: 'FAILURE', // page three-b
  CLOSE: 'CLOSE', // not a page, but an indication to close
};

export default stepsEnum;
